/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { FinalPageIds } from '@/enums'
import { DiscountsSection, EstimatedCostsSection, MemberDiscounts, OffersSection } from '@/model'
import AppointmentForm from './AppointmentForm'
import PriceComparison from './PriceComparison'

export default class FinalPage {
  private finalPageJson: any
  private offersJson?: any
  public estimatedCosts?: EstimatedCostsSection;
  public memberDiscounts?: MemberDiscounts;
  public priceComparison?: PriceComparison;
  public discountsSection?: DiscountsSection;
  public offersSection?: OffersSection;
  public appointmentForm?: AppointmentForm;

  constructor (finalPageJson: any, offersJson?: any) {
    this.finalPageJson = finalPageJson
    this.offersJson = offersJson
    this.estimatedCosts = this.getSectionById(FinalPageIds.EstimatedCosts)
    this.memberDiscounts = this.getSectionById(FinalPageIds.MemberDiscounts)
    this.priceComparison = this.getSectionById(FinalPageIds.PriceComparison)
    this.discountsSection = this.getSectionById(FinalPageIds.DiscountsSection)
    this.offersSection = this.getSectionById(FinalPageIds.OffersSection)
    this.appointmentForm = this.getSectionById(FinalPageIds.AppointmentForm)
  }

  static of (finalPageJson: any, offersJson?: any): FinalPage {
    return new FinalPage(finalPageJson, offersJson)
  }

  static empty (): FinalPage {
    return new FinalPage({})
  }

  private getSectionById = (id: string): any => {
    const section = this.finalPageJson.sections?.find((section: any) => section._content_type_uid === id)
    if (!section) {
      return
    }

    switch (id) {
      case FinalPageIds.EstimatedCosts: {
        return EstimatedCostsSection.of(section)
      }
      case FinalPageIds.MemberDiscounts: {
        return MemberDiscounts.of(section)
      }
      case FinalPageIds.PriceComparison: {
        return PriceComparison.of(section)
      }
      case FinalPageIds.DiscountsSection: {
        return DiscountsSection.of(section)
      }
      case FinalPageIds.OffersSection: {
        return OffersSection.of(section, this.offersJson)
      }
      case FinalPageIds.AppointmentForm: {
        return AppointmentForm.of(section)
      }
    }
  }
}
